/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Icon Component
 *
 * @file Icon.js
 * @author Gladson Samuel S
 * @since 0.0.1
 */

import React from 'react';
import PropTypes from 'prop-types';

import icons from '.';

const Icon = ({ name, ...rest }) => {
  if (!icons.has(name)) return null;

  const {
    isImage
  } = rest;

  if (isImage) {
    // return base64 version of the image
    return <img src={icons.get(name)} alt="" {...rest} />;
  }

  const IconToRender = icons.get(name);

  return (
    <IconToRender {...rest} />
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired
};

export default Icon;
